export default {
  PMS_LIST: {
    Apaleo: 'Apaleo',
    Avalon: 'Avalon (canal Civitfun)',
    Avalon2: 'Avalon Standard',
    Avirato: 'Avirato',
    Bookipro: 'Bookipro',
    Catalonia: 'Catalonia',
    Cloudbeds: 'Cloudbeds',
    Elektraweb: 'Elektraweb',
    Ericsoft: 'Ericsoft',
    Guestline: 'Guestline',
    GuestPortal: 'Quohotel',
    GuestPro: 'GuestPro',
    Hestia: 'Hestia',
    Host: 'Host',
    Hoteliga: 'Hoteliga',
    Mews: 'Mews',
    Minihotel: 'Minihotel',
    Noray: 'Noray',
    Noray_htl: 'Noray Htl',
    Octorate: 'Octorate',
    Ohip: 'Opera Cloud',
    Ohtels: 'Ohtels',
    Opera: 'Opera v5',
    Othello: 'Othello',
    Passepartout: 'Passepartout',
    Porthotels: 'Porthotels',
    Protel: 'Protel',
    Rms: 'Rms',
    RoomCloud: 'RoomCloud',
    SelentaGroup: 'SelentaGroup',
    Sihot: 'Sihot',
    Sihot360: 'Sihot 360',
    Standard2: 'Standard 2',
    Standard3: 'Standard 3',
    Stelle: 'Stelle',
    Suitech: 'Suitech',
    Tecsoft: 'Tecsoft',
    Timon: 'Timón',
    Tms: 'Tms',
    Totvs: 'Totvs',
    UlysesCloud: 'Ulyses Cloud',
    Verial: 'Verial',
    Winhotel: 'Winhotel',
  },
  HCN_PRODUCT: ['ACC-HCS-CIVITFUN-HCN'],
  HCN_PMS_PERMIT: [
    'Apaleo',
    'Avalon',
    'Avalon2',
    'Bookipro',
    'Cloudbeds',
    'Ericsoft',
    'GuestPro',
    'Hestia',
    'Hoteliga',
    'Mews',
    'Noray',
    'Noray_htl',
    'Ohtels',
    'Ohip',
    'Opera',
    'Protel',
    'GuestPortal',
    'Rms',
    'Sihot',
    'Sihot360',
    'Standard3',
    'Tecsoft',
    'Timon',
    'UlysesCloud',
    'Verial',
    'Winhotel',
  ],
  HCN_PMS_PERMIT_TEXT:
    'Apaleo, Avalon (canal Civitfun), Avalon Standard, Bookipro, Cloudbeds, Ericsoft, GuestPro, Hestia, Hoteliga, Mews, Noray, Noray Htl, Ohtels, Opera Cloud, Opera v5, Protel, Quohotel, Rms, Sihot, Sihot 360, Standard 3, Tecsoft, Timón, Ulyses Cloud, Verial, Winhotel',
  AUTOINV_PRODUCT: ['ACC-HCS-CIVITFUN-AUTOINV'],
  AUTOINV_PMS_PERMIT: ['Apaleo', 'GuestPro', 'Mews', 'Ohip', 'Sihot360'],
  AUTOINV_PMS_PERMIT_TEXT: 'Apaleo, GuestPro, Mews, Opera Cloud, Sihot 360',
};
